import createAction from './createAction';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('icepick');

// 1. Initial state
const initialState = icepick.freeze({
  products: {}
});

// 2. Actions
const ADD_COMPARE_PRODUCT = 'comparision/ADD_COMPARE_PRODUCT';
const REMOVE_COMPARE_PRODUCT = 'comparision/REMOVE_COMPARE_PRODUCT';

// 3. Action creators
export function addProduct(productData) {
  return createAction(ADD_COMPARE_PRODUCT)(productData);
}

export function removeProduct(productData) {
  return createAction(REMOVE_COMPARE_PRODUCT)(productData);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  const product = action.payload && action.payload.product;
  const productSegmentId = action.payload && action.payload.productSegmentId;

  let products = [];

  switch (action.type) {
    case ADD_COMPARE_PRODUCT:
      return icepick.setIn(state, ['products', productSegmentId],
        icepick.push(state.products[productSegmentId] || [], product));

    case REMOVE_COMPARE_PRODUCT:
      products = icepick.filter(
        (savedProducts) => savedProducts.id !== product.id,
        state.products[productSegmentId]
      );

      if (products.length > 0) {
        return icepick.setIn(state, ['products', productSegmentId], products);
      }
      // If there are no products, remove segment index from products collection.
      // We want to avoid empty segment array.
      return icepick.set(state, 'products',
        icepick.unset(state.products, productSegmentId));

    default:
      return state;
  }
}
